import PropTypes from 'prop-types';
import { useState } from 'react';
import { useApolloClient } from '@apollo/client';
import BarnCreator from './BarnCreator';
import WorkshopBarnOrOrgCreationForm from './OrgCreationForm';

import './WorkshopPage';
import MockBarnSetupCard from '../../organisms/MockBarnSetupCard/MockBarnSetupCard';
import CopyButton from '../../atoms/CopyButton';

export default function OrgOnboardSection({ wrapperClassName = '', onCreate = () => {} }) {
  const [org, setOrg] = useState();
  const client = useApolloClient();

  return (
    <div className={`OrgOnboarding ${wrapperClassName}`}>
      <h1> Create Org </h1>
      <p>
        <b>New Org ID:</b>
        <span>{org?.id}</span> <CopyButton data={org?.id} />
      </p>
      <br />
      <div className="OrgOnboarding-rowWrapper">
        <WorkshopBarnOrOrgCreationForm
          fieldHasuraName="name"
          fieldTableName="organization"
          fieldLabel="Create New Org by Name"
          placeholder="New Org Name"
          onError={console.error}
          onSuccess={async (field, data) => {
            const orgInfo = data?.insert_organization_one;
            setOrg(orgInfo);
            onCreate(orgInfo);
            await client.refetchQueries({
              include: ['OrgViewer_getInfo'], // a little coupled but oh well.
            });
          }}
        />
      </div>
      <div className="OrgOnboarding-rowWrapper">
        <BarnCreator
          orgId={org?.id}
          orgName={org?.name}
          refetch={async () => {
            await client.refetchQueries({
              include: ['OrgViewer_getInfo'], // a little coupled but oh well.
            });
          }}
        />
        <p style={{ color: 'red' }}>Requires both Name and Plan</p>
      </div>
      <MockBarnSetupCard
        preselectedOrg={org}
        onSuccess={async () => {
          await client.refetchQueries({
            include: ['OrgViewer_getInfo'], // a little coupled but oh well.
          });
        }}
      />
    </div>
  );
}

OrgOnboardSection.propTypes = {
  wrapperClassName: PropTypes.string,
  onCreate: PropTypes.func,
};
